// extracted by mini-css-extract-plugin
module.exports = {"notice":"index_notice_3xHXe"};